import OrderBillingForecastPreOrderType from '../../enums/order-billing-forecast/order-billing-forecast-pre-order-type.enum';
import { OrderBillingForecastPreOrder } from '../../interfaces/order-billing-forecast/order-billing-forecast-pre-order.interfaces';
import { OrderBillingForecastReadyForDelivery } from '../../interfaces/order-billing-forecast/order-billing-forecast-ready-for-delivery.interfaces';

export const isManualInput = (
  rule: OrderBillingForecastPreOrder | OrderBillingForecastReadyForDelivery,
): boolean => {
  if ('billingForecastPreOrderType' in rule) {
    return rule.billingForecastPreOrderType === 'MANUAL_INPUT';
  }
  return rule.billingForecastReadyForDeliveryType === 'MANUAL_INPUT';
};

export const checkRule = (
  rule: OrderBillingForecastPreOrder | OrderBillingForecastReadyForDelivery | null,
) => ({
  hasRule: !!rule,
  isManual: rule ? isManualInput(rule) : false,
});

export const isRuleBasedOnDeliveryWindow = (rule: OrderBillingForecastPreOrder | null): boolean => {
  if (!rule?.billingForecastPreOrderType) {
    return false;
  }
  return [
    OrderBillingForecastPreOrderType.USE_DELIVERY_WINDOW_END_DATE,
    OrderBillingForecastPreOrderType.USE_DELIVERY_WINDOW_START_DATE,
  ].includes(rule.billingForecastPreOrderType);
};
